import { getCookie, setCookie } from './utils';

const bannerClass = 'c-banner';
const bannerOpenClass = bannerClass + '--open';

const bannerJsClass = 'js-banner';
const buttonJsClass = bannerJsClass + '-button';

const bannerElement = document.querySelector('.' + bannerJsClass) as HTMLElement;
const buttonElement = document.querySelector('.' + buttonJsClass) as HTMLElement;

if (bannerElement && buttonElement) {
    // Get the key from the data attribute
    const key = bannerElement.dataset.bannerId;

    // Get cookie to se if it exists
    const cookie = getCookie(key);

    // If the cookie doesn't exist yet the alert needs to be shown
    if (!cookie) {
        // Show the alert
        bannerElement.classList.add(bannerOpenClass);

        // Add a click event listener on the button
        buttonElement.addEventListener('click', () => {
            // If the alert is open
            if (bannerElement.classList.contains(bannerOpenClass)) {
                // Hide the alert
                bannerElement.classList.remove(bannerOpenClass);

                // Update the inert property to prevent focus
                bannerElement.inert = false;

                // Set the cookie to expire in a year
                if (key) {
                    setCookie(key, 'closed', 365);
                }
            }
        });
    }
}